<template>
  <b-modal
    ref="addTipTapModal"
    hide-footer
    centered
    :title="modalTitle"
    size="lg"
    @shown="shown = true"
    @hidden="shown = false"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
      >
        <b-form-input
          type="text"
          v-model.trim="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.title.required"
        >
          The Title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
  import {mapState} from 'vuex'
  import {required, numeric} from 'vuelidate/lib/validators'
  // helpers
  import eventBus from '@/helpers/event-bus'
  // services
  import db from '@/services/db'

  let $ = window.$
  const typeValidate = (type) =>
    (value) => value.type === type

  export default {
    props: ['widgetsComputed'],
    data () {
      return {
        title: '',
        layout: 'b-card',
        dataSource: '',
        inProgress: false,
        name: '',
        start_date: '',
        end_date: '',
        assignedTo: '',
        color: ''
      }
    },
    computed: {
      ...mapState([
        'currentTab',
        'currentSubTab',
        'computedProps',
        'dataGrid_options'
      ]),
      modalTitle () {
        return 'Create TipTap Editor'
      },
    } ,
    methods: {
      save () {
        if (this.inProgress) return
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.inProgress = true

        let data = {
          layout: 'b-card',
          title: this.title,
        //   id: this.id.value,
          // name: this.name.value,
          // start_date: this.start_date.value,
          // end_date: this.end_date.value,
          // assignedTo: this.assignedTo.value,
          // color: this.color,
        //   percent: this.percent.value,
        //   duration: this.duration.value,
          // w: 12,
          // h: 6,
          layout: 'b-card',
          tab: this.currentTab,
          subtab: this.currentSubTab,
          dataSource: this.dataSource,
        }
        this.$store.commit('addProcess', {
          process: 'addWidget',
          message: 'Creating'
        })

        db.tipTapEditor.create(data, (key) => {
          if (this.$refs.addTipTapModal) this.$refs.addTipTapModal.hide()
          this.title = null
          // this.dataSource = null
          this.$store.commit('deleteProcess', 'addWidget')
          // this.$store.commit('editWidget', {
          //   key,
          //   insert: true
          // })
          this.inProgress = false
          this.$nextTick(() => {
            this.$v.$reset()
          })
        })
      }
    },
    validations: {
      title: {
        required
      }
    },
    created () {
      eventBus.$on('addTipTapEditor', (widgetType) => {
        if (this.$refs.addTipTapModal) this.$refs.addTipTapModal.show()
      })
    }
  }
</script>

<style lang="scss">
  @import '~$scss/globals';

  .templateEditor {
    height: 40vh;
    border: 1px solid $borderColor1;
  }

  .vue-codemirror {
    height: 100%;
  }

  .CodeMirror {
    height: 100%;
  }

  .gridstackSize {
    @include cf;

    &__item {
      @include span(6)

      &:first-child {
        padding-right: 10px;
      }

      &:last-child {
        padding-left: 20px;
      }

      @include breakpoint(max-width $screenSm) {
        @include span(12)
        &:first-child {
          padding-right: 0;
        }
        &:last-child {
          padding-left: 0;
        }
      }
    }
  }
</style>
